<template>
    <div>
        <wrapper-edit
                :wrapper-width="wrapperWidth"
                @back="paasPageBack">
            <Form ref="paasForm" slot="form"
                  :model="paasFormData"
                  :rules="paasFormRules"
                  :label-width="defaultLabelWidth">
                <Row>
                    <FormItem label="名称：" prop="name" class="ivu-col-span-16" >
                        <Input v-model="paasFormData.name"
                               clearable ></Input>

                    </FormItem>
                </Row>
                <Row>
                    <FormItem label="面值：" prop="couponPrice" class="ivu-col-span-16" >
                        <Input v-model="paasFormData.couponPrice"
                               clearable ></Input>

                    </FormItem>
                </Row>
                <Row>
                    <FormItem label="最低消费：" prop="useMinPrice" class="ivu-col-span-16" >
                        <Input v-model="paasFormData.useMinPrice"
                               clearable ></Input>

                    </FormItem>
                </Row>
                <Row>
                    <FormItem label="每人限领：" prop="atMost" class="ivu-col-span-16" >
                        <Input v-model="paasFormData.atMost"
                               clearable ></Input>

                    </FormItem>
                </Row>
                <Row>
                    <FormItem label="开启时间：" prop="couponStartTime" class="ivu-col-span-12" >

                        <DatePicker type="date" format="yyyy-MM-dd"
                                    v-model="paasFormData.couponStartTime"
                                    confirm clearable></DatePicker >
                    </FormItem>
                </Row>
                <Row>
                    <FormItem label="结束时间：" prop="couponEndTime" class="ivu-col-span-12" >

                        <DatePicker type="date" format="yyyy-MM-dd"
                                    v-model="paasFormData.couponEndTime"
                                    confirm clearable></DatePicker >
                    </FormItem>
                </Row>
                <Row>
                    <FormItem label="优惠券类型：" prop="couponType" class="ivu-col-span-16" >
                        <Enum :enumJsonKey="'crmdict-couponType'"  v-model="paasFormData.couponType">
                        </Enum>
                    </FormItem>
                </Row>
                <!--<Row>
                    <FormItem label="排序：" prop="sort" class="ivu-col-span-24" >
                        <Input v-model="paasFormData.sort"
                               clearable ></Input>

                    </FormItem>
                </Row>-->
                <!--<Row>
                    <FormItem label="状态：" prop="status" class="ivu-col-span-24" >
                        <Enum :enumJsonKey="'-'"  v-model="paasFormData.status"  type="single" ></Enum>

                    </FormItem>
                </Row>-->
                <div class="edit-oper-toolbar">
                    <Button type="primary" @click="paasFormSubmit('paasForm','','add')">保存并继续添加</Button>
                    <Button @click="paasFormSubmit('paasForm','','couponList')" style="margin-left: 8px">保存并返回</Button>
                    <Button @click="paasPageBack" style="margin-left: 8px">返回</Button>
                </div>
            </Form>

        </wrapper-edit>
    </div>
</template>
<script>
    import wrapperEdit from "@/components/paas/wrapper-edit";
    import metaEdit from "@/assets/js/meta-edit.js";
    import Enum from '@/components/paas/enum-form' //枚举渲染

    export default {
        name: "edit",
        mixins:[metaEdit],
        components:{wrapperEdit,Enum},
        data(){
            return {
                serviceUrl:"/member/coupon",  //每个页面访问后台服务器的路径
                currentIdFiledName: 'id',
                paasFormData:{
                    couponPrice:'',
                    useMinPrice:'',
                    couponStartTime:'',
                    couponEndTime:'',
                    couponType:'',
                    productIds:'',
                    atMost:'',
                    id:'',
                    name:'',
                    createTime:'',
                    updateTime:'',
                    createUserId:'',
                    createUserName:'',
                    isDelete:'',
                },
                paasFormRules:{
                },
                redirectName:"couponList",
                nextAddName:"couponEdit",
            }
        },
        methods:{
        }
    }
</script>